export default "__VITE_ASSET__7SHsTzQo__"